var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.title === "new"
      ? _c("div", { staticClass: "new-logo" }, [_vm._v("\n    新\n  ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.title === "vip"
      ? _c("div", { staticClass: "vip-logo" }, [_vm._v("\n    VIP\n  ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.title === "vip-film"
      ? _c("div", { staticClass: "vip-logo-film" }, [_vm._v("\n    VIP\n  ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }